import { IS_EMBEDDED } from 'constants/embedding'

import { useGetWorkspaceQuery, WorkspaceMinimalFragment } from 'gqlTypes'
import useUserSignedIn from 'modules/user/useUserSignedIn'
import { ShareWithoutVersion } from 'modules/versioning/ShareVersionContext/ShareVersionContext'
import { useGetWorkspaces } from 'modules/workspace/operations'

/**
 * Handles the logic & queries related to the left sidebar showing
 * workspaces and projects in the DocumentView, DetailView and PageCanvasView.
 * The navbar is only shown for signed in users and when the document is not embedded,
 * so data is only requested if needed.
 */
export function useShareWorkspaceSidebar(share: ShareWithoutVersion) {
  const isSignedIn = useUserSignedIn()
  const { data: workspaceData } = useGetWorkspaceQuery({
    variables: { identifier: share.workspace.identifier },
  })
  const workspace = workspaceData?.workspace as WorkspaceMinimalFragment
  const { workspaces, error: workspacesError } = useGetWorkspaces({
    skip: !isSignedIn || IS_EMBEDDED,
  })

  const shouldRenderWorkspaceSidebar =
    !IS_EMBEDDED &&
    !workspacesError &&
    isSignedIn &&
    !!workspace &&
    !!workspaces?.length

  return {
    shouldRenderWorkspaceSidebar,
    workspace,
    workspaces,
  }
}
